import _extends from "@babel/runtime/helpers/esm/extends";
import { useCallback } from 'react';
import useEnsureIdentHandler from '@sprinx/react-entity-hooks/useEnsureIdentHandler';
export default function useMulticurrencyToItem(currencyFieldsConfig, currency) {
  var toCurrencyCode = useEnsureIdentHandler(currencyFieldsConfig);
  return useCallback(function (multicurrency) {
    var crr = toCurrencyCode(currency || 'EUR');
    var price = multicurrency.find(function (i) {
      return toCurrencyCode(i.currency) === crr;
    }) || {
      currency: crr,
      amount: undefined
    };
    return _extends({}, price, {
      currency: toCurrencyCode(price.currency)
    });
  }, [currency, toCurrencyCode]);
}